import HttpClient from '../HttpService';

function list(companyId) {
    return HttpClient.get(`/workergroups/${companyId}`);
}

function create(data) {
    return HttpClient.post('/workergroups', data);
}

function update(data) {
    return HttpClient.put(`/workergroups/${data.id}`, data);
}

function destroy(groupId, companyId) {
    return HttpClient.delete(`/workergroups/${groupId}`, {
        data: {
            company: companyId
        }
    });
}

function assignWorker(companyId, workerId, workerGroupId, sourceWorkerGroupId = null) {
    return HttpClient.put('/workergroups/assign', {
        company: companyId,
        worker_id: workerId,
        worker_group_id: workerGroupId,
        source_worker_group_id: sourceWorkerGroupId
    });
}

function reorderGroup(companyId, workerGroupId, workerIds) {
    return HttpClient.put('/workergroups/reorder', {
        company: companyId,
        worker_group_id: workerGroupId,
        worker_ids: workerIds
    });
}

export default {
    assignWorker,
    create,
    destroy,
    list,
    reorderGroup,
    update
};
